import script from "./TableauProduit.vue?vue&type=script&setup=true&lang=js"
export * from "./TableauProduit.vue?vue&type=script&setup=true&lang=js"

import "./TableauProduit.vue?vue&type=style&index=0&id=765635d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765635d6"]])

export default __exports__